import { _ as se, a as f } from "./react-dropzone.DBUV1vcP.js";
import * as C from "react";
import { g as ce } from "./lodash.DGoHQECz.js";
var j = !1, y, A, W, E, b, q, D, T, N, F, $, O, L, J, K;
function l() {
  if (!j) {
    j = !0;
    var i = navigator.userAgent, r = /(?:MSIE.(\d+\.\d+))|(?:(?:Firefox|GranParadiso|Iceweasel).(\d+\.\d+))|(?:Opera(?:.+Version.|.)(\d+\.\d+))|(?:AppleWebKit.(\d+(?:\.\d+)?))|(?:Trident\/\d+\.\d+.*rv:(\d+\.\d+))/.exec(i), e = /(Mac OS X)|(Windows)|(Linux)/.exec(i);
    if (O = /\b(iPhone|iP[ao]d)/.exec(i), L = /\b(iP[ao]d)/.exec(i), F = /Android/i.exec(i), J = /FBAN\/\w+;/i.exec(i), K = /Mobile/i.exec(i), $ = !!/Win64/.exec(i), r) {
      y = r[1] ? parseFloat(r[1]) : r[5] ? parseFloat(r[5]) : NaN, y && document && document.documentMode && (y = document.documentMode);
      var t = /(?:Trident\/(\d+.\d+))/.exec(i);
      q = t ? parseFloat(t[1]) + 4 : y, A = r[2] ? parseFloat(r[2]) : NaN, W = r[3] ? parseFloat(r[3]) : NaN, E = r[4] ? parseFloat(r[4]) : NaN, E ? (r = /(?:Chrome\/(\d+\.\d+))/.exec(i), b = r && r[1] ? parseFloat(r[1]) : NaN) : b = NaN;
    } else
      y = A = W = b = E = NaN;
    if (e) {
      if (e[1]) {
        var o = /(?:Mac OS X (\d+(?:[._]\d+)?))/.exec(i);
        D = o ? parseFloat(o[1].replace("_", ".")) : !0;
      } else
        D = !1;
      T = !!e[2], N = !!e[3];
    } else
      D = T = N = !1;
  }
}
var Z = {
  /**
   *  Check if the UA is Internet Explorer.
   *
   *
   *  @return float|NaN Version number (if match) or NaN.
   */
  ie: function() {
    return l() || y;
  },
  /**
   * Check if we're in Internet Explorer compatibility mode.
   *
   * @return bool true if in compatibility mode, false if
   * not compatibility mode or not ie
   */
  ieCompatibilityMode: function() {
    return l() || q > y;
  },
  /**
   * Whether the browser is 64-bit IE.  Really, this is kind of weak sauce;  we
   * only need this because Skype can't handle 64-bit IE yet.  We need to remove
   * this when we don't need it -- tracked by #601957.
   */
  ie64: function() {
    return Z.ie() && $;
  },
  /**
   *  Check if the UA is Firefox.
   *
   *
   *  @return float|NaN Version number (if match) or NaN.
   */
  firefox: function() {
    return l() || A;
  },
  /**
   *  Check if the UA is Opera.
   *
   *
   *  @return float|NaN Version number (if match) or NaN.
   */
  opera: function() {
    return l() || W;
  },
  /**
   *  Check if the UA is WebKit.
   *
   *
   *  @return float|NaN Version number (if match) or NaN.
   */
  webkit: function() {
    return l() || E;
  },
  /**
   *  For Push
   *  WILL BE REMOVED VERY SOON. Use UserAgent_DEPRECATED.webkit
   */
  safari: function() {
    return Z.webkit();
  },
  /**
   *  Check if the UA is a Chrome browser.
   *
   *
   *  @return float|NaN Version number (if match) or NaN.
   */
  chrome: function() {
    return l() || b;
  },
  /**
   *  Check if the user is running Windows.
   *
   *  @return bool `true' if the user's OS is Windows.
   */
  windows: function() {
    return l() || T;
  },
  /**
   *  Check if the user is running Mac OS X.
   *
   *  @return float|bool   Returns a float if a version number is detected,
   *                       otherwise true/false.
   */
  osx: function() {
    return l() || D;
  },
  /**
   * Check if the user is running Linux.
   *
   * @return bool `true' if the user's OS is some flavor of Linux.
   */
  linux: function() {
    return l() || N;
  },
  /**
   * Check if the user is running on an iPhone or iPod platform.
   *
   * @return bool `true' if the user is running some flavor of the
   *    iPhone OS.
   */
  iphone: function() {
    return l() || O;
  },
  mobile: function() {
    return l() || O || L || F || K;
  },
  nativeApp: function() {
    return l() || J;
  },
  android: function() {
    return l() || F;
  },
  ipad: function() {
    return l() || L;
  }
}, he = Z, ue = !!(typeof window < "u" && window.document && window.document.createElement), pe = {
  canUseDOM: ue
}, de = pe, Q = de, ee;
Q.canUseDOM && (ee = document.implementation && document.implementation.hasFeature && // always returns true in newer browsers as per the standard.
// @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
document.implementation.hasFeature("", "") !== !0);
/**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @param {?boolean} capture Check if the capture phase is supported.
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */
function le(i, r) {
  if (!Q.canUseDOM || r && !("addEventListener" in document))
    return !1;
  var e = "on" + i, t = e in document;
  if (!t) {
    var o = document.createElement("div");
    o.setAttribute(e, "return;"), t = typeof o[e] == "function";
  }
  return !t && ee && i === "wheel" && (t = document.implementation.hasFeature("Events.wheel", "3.0")), t;
}
var fe = le, ve = he, me = fe, G = 10, X = 40, B = 800;
function te(i) {
  var r = 0, e = 0, t = 0, o = 0;
  return "detail" in i && (e = i.detail), "wheelDelta" in i && (e = -i.wheelDelta / 120), "wheelDeltaY" in i && (e = -i.wheelDeltaY / 120), "wheelDeltaX" in i && (r = -i.wheelDeltaX / 120), "axis" in i && i.axis === i.HORIZONTAL_AXIS && (r = e, e = 0), t = r * G, o = e * G, "deltaY" in i && (o = i.deltaY), "deltaX" in i && (t = i.deltaX), (t || o) && i.deltaMode && (i.deltaMode == 1 ? (t *= X, o *= X) : (t *= B, o *= B)), t && !r && (r = t < 1 ? -1 : 1), o && !e && (e = o < 1 ? -1 : 1), {
    spinX: r,
    spinY: e,
    pixelX: t,
    pixelY: o
  };
}
te.getEventType = function() {
  return ve.firefox() ? "DOMMouseScroll" : me("wheel") ? "wheel" : "mousewheel";
};
var ge = te, we = ge;
const Ce = /* @__PURE__ */ ce(we);
function ye(i, r, e, t, o, n) {
  n === void 0 && (n = 0);
  var s = x(i, r, n), a = s.width, c = s.height, h = Math.min(a, e), u = Math.min(c, t);
  return h > u * o ? {
    width: u * o,
    height: u
  } : {
    width: h,
    height: h / o
  };
}
function Re(i) {
  return i.width > i.height ? i.width / i.naturalWidth : i.height / i.naturalHeight;
}
function S(i, r, e, t, o) {
  o === void 0 && (o = 0);
  var n = x(r.width, r.height, o), s = n.width, a = n.height;
  return {
    x: U(i.x, s, e.width, t),
    y: U(i.y, a, e.height, t)
  };
}
function U(i, r, e, t) {
  var o = r * t / 2 - e / 2;
  return P(i, -o, o);
}
function Y(i, r) {
  return Math.sqrt(Math.pow(i.y - r.y, 2) + Math.pow(i.x - r.x, 2));
}
function V(i, r) {
  return Math.atan2(r.y - i.y, r.x - i.x) * 180 / Math.PI;
}
function xe(i, r, e, t, o, n, s) {
  n === void 0 && (n = 0), s === void 0 && (s = !0);
  var a = s ? Se : _e, c = x(r.width, r.height, n), h = x(r.naturalWidth, r.naturalHeight, n), u = {
    x: a(100, ((c.width - e.width / o) / 2 - i.x / o) / c.width * 100),
    y: a(100, ((c.height - e.height / o) / 2 - i.y / o) / c.height * 100),
    width: a(100, e.width / c.width * 100 / o),
    height: a(100, e.height / c.height * 100 / o)
  }, p = Math.round(a(h.width, u.width * h.width / 100)), d = Math.round(a(h.height, u.height * h.height / 100)), w = h.width >= h.height * t, v = w ? {
    width: Math.round(d * t),
    height: d
  } : {
    width: p,
    height: Math.round(p / t)
  }, g = f(f({}, v), {
    x: Math.round(a(h.width - v.width, u.x * h.width / 100)),
    y: Math.round(a(h.height - v.height, u.y * h.height / 100))
  });
  return {
    croppedAreaPercentages: u,
    croppedAreaPixels: g
  };
}
function Se(i, r) {
  return Math.min(i, Math.max(0, r));
}
function _e(i, r) {
  return r;
}
function Ee(i, r, e, t, o, n) {
  var s = x(r.width, r.height, e), a = P(t.width / s.width * (100 / i.width), o, n), c = {
    x: a * s.width / 2 - t.width / 2 - s.width * a * (i.x / 100),
    y: a * s.height / 2 - t.height / 2 - s.height * a * (i.y / 100)
  };
  return {
    crop: c,
    zoom: a
  };
}
function be(i, r, e) {
  var t = Re(r);
  return e.height > e.width ? e.height / (i.height * t) : e.width / (i.width * t);
}
function De(i, r, e, t, o, n) {
  e === void 0 && (e = 0);
  var s = x(r.naturalWidth, r.naturalHeight, e), a = P(be(i, r, t), o, n), c = t.height > t.width ? t.height / i.height : t.width / i.width, h = {
    x: ((s.width - i.width) / 2 - i.x) * c,
    y: ((s.height - i.height) / 2 - i.y) * c
  };
  return {
    crop: h,
    zoom: a
  };
}
function k(i, r) {
  return {
    x: (r.x + i.x) / 2,
    y: (r.y + i.y) / 2
  };
}
function Pe(i) {
  return i * Math.PI / 180;
}
function x(i, r, e) {
  var t = Pe(e);
  return {
    width: Math.abs(Math.cos(t) * i) + Math.abs(Math.sin(t) * r),
    height: Math.abs(Math.sin(t) * i) + Math.abs(Math.cos(t) * r)
  };
}
function P(i, r, e) {
  return Math.min(Math.max(i, r), e);
}
function _() {
  for (var i = [], r = 0; r < arguments.length; r++)
    i[r] = arguments[r];
  return i.filter(function(e) {
    return typeof e == "string" && e.length > 0;
  }).join(" ").trim();
}
var Me = `.reactEasyCrop_Container {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  user-select: none;
  touch-action: none;
  cursor: move;
  display: flex;
  justify-content: center;
  align-items: center;
}

.reactEasyCrop_Image,
.reactEasyCrop_Video {
  will-change: transform; /* this improves performances and prevent painting issues on iOS Chrome */
}

.reactEasyCrop_Contain {
  max-width: 100%;
  max-height: 100%;
  margin: auto;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
.reactEasyCrop_Cover_Horizontal {
  width: 100%;
  height: auto;
}
.reactEasyCrop_Cover_Vertical {
  width: auto;
  height: 100%;
}

.reactEasyCrop_CropArea {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  border: 1px solid rgba(255, 255, 255, 0.5);
  box-sizing: border-box;
  box-shadow: 0 0 0 9999em;
  color: rgba(0, 0, 0, 0.5);
  overflow: hidden;
}

.reactEasyCrop_CropAreaRound {
  border-radius: 50%;
}

.reactEasyCrop_CropAreaGrid::before {
  content: ' ';
  box-sizing: border-box;
  position: absolute;
  border: 1px solid rgba(255, 255, 255, 0.5);
  top: 0;
  bottom: 0;
  left: 33.33%;
  right: 33.33%;
  border-top: 0;
  border-bottom: 0;
}

.reactEasyCrop_CropAreaGrid::after {
  content: ' ';
  box-sizing: border-box;
  position: absolute;
  border: 1px solid rgba(255, 255, 255, 0.5);
  top: 33.33%;
  bottom: 33.33%;
  left: 0;
  right: 0;
  border-left: 0;
  border-right: 0;
}
`, ze = 1, Ae = 3, Ne = (
  /** @class */
  function(i) {
    se(r, i);
    function r() {
      var e = i !== null && i.apply(this, arguments) || this;
      return e.imageRef = C.createRef(), e.videoRef = C.createRef(), e.containerPosition = {
        x: 0,
        y: 0
      }, e.containerRef = null, e.styleRef = null, e.containerRect = null, e.mediaSize = {
        width: 0,
        height: 0,
        naturalWidth: 0,
        naturalHeight: 0
      }, e.dragStartPosition = {
        x: 0,
        y: 0
      }, e.dragStartCrop = {
        x: 0,
        y: 0
      }, e.gestureZoomStart = 0, e.gestureRotationStart = 0, e.isTouching = !1, e.lastPinchDistance = 0, e.lastPinchRotation = 0, e.rafDragTimeout = null, e.rafPinchTimeout = null, e.wheelTimer = null, e.currentDoc = typeof document < "u" ? document : null, e.currentWindow = typeof window < "u" ? window : null, e.resizeObserver = null, e.state = {
        cropSize: null,
        hasWheelJustStarted: !1,
        mediaObjectFit: void 0
      }, e.initResizeObserver = function() {
        if (!(typeof window.ResizeObserver > "u" || !e.containerRef)) {
          var t = !0;
          e.resizeObserver = new window.ResizeObserver(function(o) {
            if (t) {
              t = !1;
              return;
            }
            e.computeSizes();
          }), e.resizeObserver.observe(e.containerRef);
        }
      }, e.preventZoomSafari = function(t) {
        return t.preventDefault();
      }, e.cleanEvents = function() {
        e.currentDoc && (e.currentDoc.removeEventListener("mousemove", e.onMouseMove), e.currentDoc.removeEventListener("mouseup", e.onDragStopped), e.currentDoc.removeEventListener("touchmove", e.onTouchMove), e.currentDoc.removeEventListener("touchend", e.onDragStopped), e.currentDoc.removeEventListener("gesturemove", e.onGestureMove), e.currentDoc.removeEventListener("gestureend", e.onGestureEnd), e.currentDoc.removeEventListener("scroll", e.onScroll));
      }, e.clearScrollEvent = function() {
        e.containerRef && e.containerRef.removeEventListener("wheel", e.onWheel), e.wheelTimer && clearTimeout(e.wheelTimer);
      }, e.onMediaLoad = function() {
        var t = e.computeSizes();
        t && (e.emitCropData(), e.setInitialCrop(t)), e.props.onMediaLoaded && e.props.onMediaLoaded(e.mediaSize);
      }, e.setInitialCrop = function(t) {
        if (e.props.initialCroppedAreaPercentages) {
          var o = Ee(e.props.initialCroppedAreaPercentages, e.mediaSize, e.props.rotation, t, e.props.minZoom, e.props.maxZoom), n = o.crop, s = o.zoom;
          e.props.onCropChange(n), e.props.onZoomChange && e.props.onZoomChange(s);
        } else if (e.props.initialCroppedAreaPixels) {
          var a = De(e.props.initialCroppedAreaPixels, e.mediaSize, e.props.rotation, t, e.props.minZoom, e.props.maxZoom), n = a.crop, s = a.zoom;
          e.props.onCropChange(n), e.props.onZoomChange && e.props.onZoomChange(s);
        }
      }, e.computeSizes = function() {
        var t, o, n, s, a, c, h = e.imageRef.current || e.videoRef.current;
        if (h && e.containerRef) {
          e.containerRect = e.containerRef.getBoundingClientRect(), e.saveContainerPosition();
          var u = e.containerRect.width / e.containerRect.height, p = ((t = e.imageRef.current) === null || t === void 0 ? void 0 : t.naturalWidth) || ((o = e.videoRef.current) === null || o === void 0 ? void 0 : o.videoWidth) || 0, d = ((n = e.imageRef.current) === null || n === void 0 ? void 0 : n.naturalHeight) || ((s = e.videoRef.current) === null || s === void 0 ? void 0 : s.videoHeight) || 0, w = h.offsetWidth < p || h.offsetHeight < d, v = p / d, g = void 0;
          if (w)
            switch (e.state.mediaObjectFit) {
              default:
              case "contain":
                g = u > v ? {
                  width: e.containerRect.height * v,
                  height: e.containerRect.height
                } : {
                  width: e.containerRect.width,
                  height: e.containerRect.width / v
                };
                break;
              case "horizontal-cover":
                g = {
                  width: e.containerRect.width,
                  height: e.containerRect.width / v
                };
                break;
              case "vertical-cover":
                g = {
                  width: e.containerRect.height * v,
                  height: e.containerRect.height
                };
                break;
            }
          else
            g = {
              width: h.offsetWidth,
              height: h.offsetHeight
            };
          e.mediaSize = f(f({}, g), {
            naturalWidth: p,
            naturalHeight: d
          }), e.props.setMediaSize && e.props.setMediaSize(e.mediaSize);
          var m = e.props.cropSize ? e.props.cropSize : ye(e.mediaSize.width, e.mediaSize.height, e.containerRect.width, e.containerRect.height, e.props.aspect, e.props.rotation);
          return (((a = e.state.cropSize) === null || a === void 0 ? void 0 : a.height) !== m.height || ((c = e.state.cropSize) === null || c === void 0 ? void 0 : c.width) !== m.width) && e.props.onCropSizeChange && e.props.onCropSizeChange(m), e.setState({
            cropSize: m
          }, e.recomputeCropPosition), e.props.setCropSize && e.props.setCropSize(m), m;
        }
      }, e.saveContainerPosition = function() {
        if (e.containerRef) {
          var t = e.containerRef.getBoundingClientRect();
          e.containerPosition = {
            x: t.left,
            y: t.top
          };
        }
      }, e.onMouseDown = function(t) {
        e.currentDoc && (t.preventDefault(), e.currentDoc.addEventListener("mousemove", e.onMouseMove), e.currentDoc.addEventListener("mouseup", e.onDragStopped), e.saveContainerPosition(), e.onDragStart(r.getMousePoint(t)));
      }, e.onMouseMove = function(t) {
        return e.onDrag(r.getMousePoint(t));
      }, e.onScroll = function(t) {
        e.currentDoc && (t.preventDefault(), e.saveContainerPosition());
      }, e.onTouchStart = function(t) {
        e.currentDoc && (e.isTouching = !0, !(e.props.onTouchRequest && !e.props.onTouchRequest(t)) && (e.currentDoc.addEventListener("touchmove", e.onTouchMove, {
          passive: !1
        }), e.currentDoc.addEventListener("touchend", e.onDragStopped), e.saveContainerPosition(), t.touches.length === 2 ? e.onPinchStart(t) : t.touches.length === 1 && e.onDragStart(r.getTouchPoint(t.touches[0]))));
      }, e.onTouchMove = function(t) {
        t.preventDefault(), t.touches.length === 2 ? e.onPinchMove(t) : t.touches.length === 1 && e.onDrag(r.getTouchPoint(t.touches[0]));
      }, e.onGestureStart = function(t) {
        e.currentDoc && (t.preventDefault(), e.currentDoc.addEventListener("gesturechange", e.onGestureMove), e.currentDoc.addEventListener("gestureend", e.onGestureEnd), e.gestureZoomStart = e.props.zoom, e.gestureRotationStart = e.props.rotation);
      }, e.onGestureMove = function(t) {
        if (t.preventDefault(), !e.isTouching) {
          var o = r.getMousePoint(t), n = e.gestureZoomStart - 1 + t.scale;
          if (e.setNewZoom(n, o, {
            shouldUpdatePosition: !0
          }), e.props.onRotationChange) {
            var s = e.gestureRotationStart + t.rotation;
            e.props.onRotationChange(s);
          }
        }
      }, e.onGestureEnd = function(t) {
        e.cleanEvents();
      }, e.onDragStart = function(t) {
        var o, n, s = t.x, a = t.y;
        e.dragStartPosition = {
          x: s,
          y: a
        }, e.dragStartCrop = f({}, e.props.crop), (n = (o = e.props).onInteractionStart) === null || n === void 0 || n.call(o);
      }, e.onDrag = function(t) {
        var o = t.x, n = t.y;
        e.currentWindow && (e.rafDragTimeout && e.currentWindow.cancelAnimationFrame(e.rafDragTimeout), e.rafDragTimeout = e.currentWindow.requestAnimationFrame(function() {
          if (e.state.cropSize && !(o === void 0 || n === void 0)) {
            var s = o - e.dragStartPosition.x, a = n - e.dragStartPosition.y, c = {
              x: e.dragStartCrop.x + s,
              y: e.dragStartCrop.y + a
            }, h = e.props.restrictPosition ? S(c, e.mediaSize, e.state.cropSize, e.props.zoom, e.props.rotation) : c;
            e.props.onCropChange(h);
          }
        }));
      }, e.onDragStopped = function() {
        var t, o;
        e.isTouching = !1, e.cleanEvents(), e.emitCropData(), (o = (t = e.props).onInteractionEnd) === null || o === void 0 || o.call(t);
      }, e.onWheel = function(t) {
        if (e.currentWindow && !(e.props.onWheelRequest && !e.props.onWheelRequest(t))) {
          t.preventDefault();
          var o = r.getMousePoint(t), n = Ce(t).pixelY, s = e.props.zoom - n * e.props.zoomSpeed / 200;
          e.setNewZoom(s, o, {
            shouldUpdatePosition: !0
          }), e.state.hasWheelJustStarted || e.setState({
            hasWheelJustStarted: !0
          }, function() {
            var a, c;
            return (c = (a = e.props).onInteractionStart) === null || c === void 0 ? void 0 : c.call(a);
          }), e.wheelTimer && clearTimeout(e.wheelTimer), e.wheelTimer = e.currentWindow.setTimeout(function() {
            return e.setState({
              hasWheelJustStarted: !1
            }, function() {
              var a, c;
              return (c = (a = e.props).onInteractionEnd) === null || c === void 0 ? void 0 : c.call(a);
            });
          }, 250);
        }
      }, e.getPointOnContainer = function(t, o) {
        var n = t.x, s = t.y;
        if (!e.containerRect)
          throw new Error("The Cropper is not mounted");
        return {
          x: e.containerRect.width / 2 - (n - o.x),
          y: e.containerRect.height / 2 - (s - o.y)
        };
      }, e.getPointOnMedia = function(t) {
        var o = t.x, n = t.y, s = e.props, a = s.crop, c = s.zoom;
        return {
          x: (o + a.x) / c,
          y: (n + a.y) / c
        };
      }, e.setNewZoom = function(t, o, n) {
        var s = n === void 0 ? {} : n, a = s.shouldUpdatePosition, c = a === void 0 ? !0 : a;
        if (!(!e.state.cropSize || !e.props.onZoomChange)) {
          var h = P(t, e.props.minZoom, e.props.maxZoom);
          if (c) {
            var u = e.getPointOnContainer(o, e.containerPosition), p = e.getPointOnMedia(u), d = {
              x: p.x * h - u.x,
              y: p.y * h - u.y
            }, w = e.props.restrictPosition ? S(d, e.mediaSize, e.state.cropSize, h, e.props.rotation) : d;
            e.props.onCropChange(w);
          }
          e.props.onZoomChange(h);
        }
      }, e.getCropData = function() {
        if (!e.state.cropSize)
          return null;
        var t = e.props.restrictPosition ? S(e.props.crop, e.mediaSize, e.state.cropSize, e.props.zoom, e.props.rotation) : e.props.crop;
        return xe(t, e.mediaSize, e.state.cropSize, e.getAspect(), e.props.zoom, e.props.rotation, e.props.restrictPosition);
      }, e.emitCropData = function() {
        var t = e.getCropData();
        if (t) {
          var o = t.croppedAreaPercentages, n = t.croppedAreaPixels;
          e.props.onCropComplete && e.props.onCropComplete(o, n), e.props.onCropAreaChange && e.props.onCropAreaChange(o, n);
        }
      }, e.emitCropAreaChange = function() {
        var t = e.getCropData();
        if (t) {
          var o = t.croppedAreaPercentages, n = t.croppedAreaPixels;
          e.props.onCropAreaChange && e.props.onCropAreaChange(o, n);
        }
      }, e.recomputeCropPosition = function() {
        if (e.state.cropSize) {
          var t = e.props.restrictPosition ? S(e.props.crop, e.mediaSize, e.state.cropSize, e.props.zoom, e.props.rotation) : e.props.crop;
          e.props.onCropChange(t), e.emitCropData();
        }
      }, e;
    }
    return r.prototype.componentDidMount = function() {
      !this.currentDoc || !this.currentWindow || (this.containerRef && (this.containerRef.ownerDocument && (this.currentDoc = this.containerRef.ownerDocument), this.currentDoc.defaultView && (this.currentWindow = this.currentDoc.defaultView), this.initResizeObserver(), typeof window.ResizeObserver > "u" && this.currentWindow.addEventListener("resize", this.computeSizes), this.props.zoomWithScroll && this.containerRef.addEventListener("wheel", this.onWheel, {
        passive: !1
      }), this.containerRef.addEventListener("gesturestart", this.onGestureStart)), this.currentDoc.addEventListener("scroll", this.onScroll), this.props.disableAutomaticStylesInjection || (this.styleRef = this.currentDoc.createElement("style"), this.styleRef.setAttribute("type", "text/css"), this.props.nonce && this.styleRef.setAttribute("nonce", this.props.nonce), this.styleRef.innerHTML = Me, this.currentDoc.head.appendChild(this.styleRef)), this.imageRef.current && this.imageRef.current.complete && this.onMediaLoad(), this.props.setImageRef && this.props.setImageRef(this.imageRef), this.props.setVideoRef && this.props.setVideoRef(this.videoRef));
    }, r.prototype.componentWillUnmount = function() {
      var e, t;
      !this.currentDoc || !this.currentWindow || (typeof window.ResizeObserver > "u" && this.currentWindow.removeEventListener("resize", this.computeSizes), (e = this.resizeObserver) === null || e === void 0 || e.disconnect(), this.containerRef && this.containerRef.removeEventListener("gesturestart", this.preventZoomSafari), this.styleRef && ((t = this.styleRef.parentNode) === null || t === void 0 || t.removeChild(this.styleRef)), this.cleanEvents(), this.props.zoomWithScroll && this.clearScrollEvent());
    }, r.prototype.componentDidUpdate = function(e) {
      var t, o, n, s, a, c, h, u, p;
      e.rotation !== this.props.rotation ? (this.computeSizes(), this.recomputeCropPosition()) : e.aspect !== this.props.aspect ? this.computeSizes() : e.objectFit !== this.props.objectFit ? this.computeSizes() : e.zoom !== this.props.zoom ? this.recomputeCropPosition() : ((t = e.cropSize) === null || t === void 0 ? void 0 : t.height) !== ((o = this.props.cropSize) === null || o === void 0 ? void 0 : o.height) || ((n = e.cropSize) === null || n === void 0 ? void 0 : n.width) !== ((s = this.props.cropSize) === null || s === void 0 ? void 0 : s.width) ? this.computeSizes() : (((a = e.crop) === null || a === void 0 ? void 0 : a.x) !== ((c = this.props.crop) === null || c === void 0 ? void 0 : c.x) || ((h = e.crop) === null || h === void 0 ? void 0 : h.y) !== ((u = this.props.crop) === null || u === void 0 ? void 0 : u.y)) && this.emitCropAreaChange(), e.zoomWithScroll !== this.props.zoomWithScroll && this.containerRef && (this.props.zoomWithScroll ? this.containerRef.addEventListener("wheel", this.onWheel, {
        passive: !1
      }) : this.clearScrollEvent()), e.video !== this.props.video && ((p = this.videoRef.current) === null || p === void 0 || p.load());
      var d = this.getObjectFit();
      d !== this.state.mediaObjectFit && this.setState({
        mediaObjectFit: d
      }, this.computeSizes);
    }, r.prototype.getAspect = function() {
      var e = this.props, t = e.cropSize, o = e.aspect;
      return t ? t.width / t.height : o;
    }, r.prototype.getObjectFit = function() {
      var e, t, o, n;
      if (this.props.objectFit === "cover") {
        var s = this.imageRef.current || this.videoRef.current;
        if (s && this.containerRef) {
          this.containerRect = this.containerRef.getBoundingClientRect();
          var a = this.containerRect.width / this.containerRect.height, c = ((e = this.imageRef.current) === null || e === void 0 ? void 0 : e.naturalWidth) || ((t = this.videoRef.current) === null || t === void 0 ? void 0 : t.videoWidth) || 0, h = ((o = this.imageRef.current) === null || o === void 0 ? void 0 : o.naturalHeight) || ((n = this.videoRef.current) === null || n === void 0 ? void 0 : n.videoHeight) || 0, u = c / h;
          return u < a ? "horizontal-cover" : "vertical-cover";
        }
        return "horizontal-cover";
      }
      return this.props.objectFit;
    }, r.prototype.onPinchStart = function(e) {
      var t = r.getTouchPoint(e.touches[0]), o = r.getTouchPoint(e.touches[1]);
      this.lastPinchDistance = Y(t, o), this.lastPinchRotation = V(t, o), this.onDragStart(k(t, o));
    }, r.prototype.onPinchMove = function(e) {
      var t = this;
      if (!(!this.currentDoc || !this.currentWindow)) {
        var o = r.getTouchPoint(e.touches[0]), n = r.getTouchPoint(e.touches[1]), s = k(o, n);
        this.onDrag(s), this.rafPinchTimeout && this.currentWindow.cancelAnimationFrame(this.rafPinchTimeout), this.rafPinchTimeout = this.currentWindow.requestAnimationFrame(function() {
          var a = Y(o, n), c = t.props.zoom * (a / t.lastPinchDistance);
          t.setNewZoom(c, s, {
            shouldUpdatePosition: !1
          }), t.lastPinchDistance = a;
          var h = V(o, n), u = t.props.rotation + (h - t.lastPinchRotation);
          t.props.onRotationChange && t.props.onRotationChange(u), t.lastPinchRotation = h;
        });
      }
    }, r.prototype.render = function() {
      var e = this, t, o = this.props, n = o.image, s = o.video, a = o.mediaProps, c = o.transform, h = o.crop, u = h.x, p = h.y, d = o.rotation, w = o.zoom, v = o.cropShape, g = o.showGrid, m = o.style, oe = m.containerStyle, re = m.cropAreaStyle, I = m.mediaStyle, M = o.classes, ie = M.containerClassName, ne = M.cropAreaClassName, H = M.mediaClassName, R = (t = this.state.mediaObjectFit) !== null && t !== void 0 ? t : this.getObjectFit();
      return C.createElement("div", {
        onMouseDown: this.onMouseDown,
        onTouchStart: this.onTouchStart,
        ref: function(ae) {
          return e.containerRef = ae;
        },
        "data-testid": "container",
        style: oe,
        className: _("reactEasyCrop_Container", ie)
      }, n ? C.createElement("img", f({
        alt: "",
        className: _("reactEasyCrop_Image", R === "contain" && "reactEasyCrop_Contain", R === "horizontal-cover" && "reactEasyCrop_Cover_Horizontal", R === "vertical-cover" && "reactEasyCrop_Cover_Vertical", H)
      }, a, {
        src: n,
        ref: this.imageRef,
        style: f(f({}, I), {
          transform: c || "translate(".concat(u, "px, ").concat(p, "px) rotate(").concat(d, "deg) scale(").concat(w, ")")
        }),
        onLoad: this.onMediaLoad
      })) : s && C.createElement("video", f({
        autoPlay: !0,
        playsInline: !0,
        loop: !0,
        muted: !0,
        className: _("reactEasyCrop_Video", R === "contain" && "reactEasyCrop_Contain", R === "horizontal-cover" && "reactEasyCrop_Cover_Horizontal", R === "vertical-cover" && "reactEasyCrop_Cover_Vertical", H)
      }, a, {
        ref: this.videoRef,
        onLoadedMetadata: this.onMediaLoad,
        style: f(f({}, I), {
          transform: c || "translate(".concat(u, "px, ").concat(p, "px) rotate(").concat(d, "deg) scale(").concat(w, ")")
        }),
        controls: !1
      }), (Array.isArray(s) ? s : [{
        src: s
      }]).map(function(z) {
        return C.createElement("source", f({
          key: z.src
        }, z));
      })), this.state.cropSize && C.createElement("div", {
        style: f(f({}, re), {
          width: this.state.cropSize.width,
          height: this.state.cropSize.height
        }),
        "data-testid": "cropper",
        className: _("reactEasyCrop_CropArea", v === "round" && "reactEasyCrop_CropAreaRound", g && "reactEasyCrop_CropAreaGrid", ne)
      }));
    }, r.defaultProps = {
      zoom: 1,
      rotation: 0,
      aspect: 4 / 3,
      maxZoom: Ae,
      minZoom: ze,
      cropShape: "rect",
      objectFit: "contain",
      showGrid: !0,
      style: {},
      classes: {},
      mediaProps: {},
      zoomSpeed: 1,
      restrictPosition: !0,
      zoomWithScroll: !0
    }, r.getMousePoint = function(e) {
      return {
        x: Number(e.clientX),
        y: Number(e.clientY)
      };
    }, r.getTouchPoint = function(e) {
      return {
        x: Number(e.clientX),
        y: Number(e.clientY)
      };
    }, r;
  }(C.Component)
);
export {
  Ne as C
};
//# sourceMappingURL=react-easy-crop.BkFVrGvM.js.map
